import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=8a2558f6&scoped=true&lang=pug"
import script from "./Summary.js?vue&type=script&lang=js&external"
export * from "./Summary.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2558f6",
  null
  
)

export default component.exports